"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ChevronDown = _interopRequireDefault(require("@decisiv/iconix/lib/components/ChevronDown"));

var _ChevronUp = _interopRequireDefault(require("@decisiv/iconix/lib/components/ChevronUp"));

var _focusWithoutScrolling = _interopRequireDefault(require("../../utils/focusWithoutScrolling"));

var _useTranslations = _interopRequireDefault(require("../../utils/useTranslations"));

var _useDebounce = _interopRequireDefault(require("../../utils/useDebounce"));

var _Button = _interopRequireDefault(require("../Button"));

var _Menu = _interopRequireDefault(require("../Menu"));

var _Popover = _interopRequireDefault(require("../Popover"));

var _schema = _interopRequireDefault(require("./schema"));

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function JumpToMenu(props, forwardedRef) {
  var items = props.items,
      label = props.label,
      globalOffset = props.offset,
      onKeyDown = props.onKeyDown,
      zIndex = props.zIndex,
      _props$openOnMouseHov = props.openOnMouseHover,
      openOnMouseHover = _props$openOnMouseHov === void 0 ? false : _props$openOnMouseHov,
      rest = _objectWithoutProperties(props, ["items", "label", "offset", "onKeyDown", "zIndex", "openOnMouseHover"]);

  var translate = (0, _useTranslations.default)();
  var itemSelected = (0, _react.useRef)(false);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isPopoverVisible = _useState2[0],
      setIsPopoverVisible = _useState2[1];

  var debouncedVisible = (0, _useDebounce.default)(isPopoverVisible, 200);

  var _useState3 = (0, _react.useState)({
    hide: function hide() {},
    isVisible: false,
    show: function show() {},
    toggle: function toggle() {},
    contentNode: null
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      popover = _useState4[0],
      setPopover = _useState4[1];

  var buttonRef = (0, _react.useRef)(null);
  var popoverRef = (0, _react.useCallback)(setPopover, [popover]);
  var menuItems = items.map(function (_ref) {
    var itemLabel = _ref.label,
        restOfItem = _objectWithoutProperties(_ref, ["label"]);

    return _objectSpread({
      id: itemLabel,
      text: itemLabel,
      label: itemLabel
    }, restOfItem);
  });
  var onRequestHide = (0, _react.useCallback)(function () {
    if (buttonRef && buttonRef.current) {
      (0, _focusWithoutScrolling.default)(buttonRef.current);
    }
  }, [buttonRef]);
  var handleKeyDown = (0, _react.useCallback)(function (event) {
    if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && !popover.isVisible) {
      event.preventDefault();
      popover.show();
    }

    onKeyDown && onKeyDown(event);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [popover, popover.show, popover.isVisible, onKeyDown]);

  var onSelectItem = function onSelectItem(_ref2) {
    var itemOffset = _ref2.offset,
        selector = _ref2.selector;
    itemSelected.current = true;
    popover.hide();
    setIsPopoverVisible(false);
    selector && (0, _utils.jumpToSelector)(selector, globalOffset, itemOffset);
  };

  var onShow = (0, _react.useCallback)(function () {
    itemSelected.current = false;
  }, []);
  var onHide = (0, _react.useCallback)(function () {
    itemSelected && !itemSelected.current && buttonRef && buttonRef.current && (0, _focusWithoutScrolling.default)(buttonRef.current);
  }, []);
  var handleMouseEnter = (0, _react.useCallback)(function () {
    setIsPopoverVisible(true);

    if (popover && popover.contentNode) {
      (0, _focusWithoutScrolling.default)(popover.contentNode);
    }
  }, [openOnMouseHover, popover, popover && popover.contentNode]);
  var handleMouseLeave = (0, _react.useCallback)(function () {
    setIsPopoverVisible(false);
  }, [openOnMouseHover, popover]);
  var handleMouseEnterButton = (0, _react.useCallback)(function () {
    if (openOnMouseHover) {
      buttonRef && buttonRef.current && (0, _focusWithoutScrolling.default)(buttonRef.current);
      setIsPopoverVisible(true);

      if (popover && popover.contentNode) {
        (0, _focusWithoutScrolling.default)(popover.contentNode);
      }
    }
  }, [openOnMouseHover, buttonRef, popover && popover.contentNode]);
  (0, _react.useEffect)(function () {
    if (!debouncedVisible) itemSelected.current = false;
  }, [debouncedVisible, itemSelected.current]);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Button.default, _extends({
    icon: popover.isVisible ? _ChevronUp.default : _ChevronDown.default,
    iconPosition: "right",
    onClick: popover.toggle,
    onKeyDown: handleKeyDown,
    ref: buttonRef,
    size: "small",
    text: translate(label, 'jumpTo.menuLabel'),
    variant: "ghost",
    onMouseEnter: handleMouseEnterButton,
    onMouseLeave: handleMouseLeave
  }, popover.ariaAttributes)), _react.default.createElement(_Popover.default, {
    contentRole: "menu",
    manageEvents: openOnMouseHover ? 'click' : false,
    onRequestHide: onRequestHide,
    ref: popoverRef,
    target: buttonRef,
    zIndex: zIndex,
    onShow: onShow,
    onHide: onHide,
    visible: openOnMouseHover ? debouncedVisible && !itemSelected.current : undefined,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, _react.default.createElement(_Menu.default, _extends({
    items: menuItems,
    onSelectItem: onSelectItem,
    ref: forwardedRef
  }, rest))));
}

var JumpToMenuWithRef = (0, _react.forwardRef)(JumpToMenu); // @ts-ignore

JumpToMenuWithRef.propTypes = _schema.default.propTypes;
var _default = JumpToMenuWithRef;
exports.default = _default;